import { c as _c } from "react/compiler-runtime";
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import React from 'react';
import { Controller } from 'react-hook-form';
import { Error } from '../Error';
import { Width } from '../Width';
import { countryOptions } from './options';
export const Country = t0 => {
  const $ = _c(22);
  const {
    name,
    control,
    errors,
    label,
    required,
    width
  } = t0;
  let t1;
  if ($[0] !== label || $[1] !== name) {
    t1 = <Label className="" htmlFor={name}>{label}</Label>;
    $[0] = label;
    $[1] = name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== label || $[4] !== name) {
    t2 = t3 => {
      const {
        field: t4
      } = t3;
      const {
        onChange,
        value
      } = t4;
      const controlledValue = countryOptions.find(t => t.value === value);
      return <Select onValueChange={val => onChange(val)} value={controlledValue?.value}><SelectTrigger className="w-full" id={name}><SelectValue placeholder={label} /></SelectTrigger><SelectContent>{countryOptions.map(_temp)}</SelectContent></Select>;
    };
    $[3] = label;
    $[4] = name;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== required) {
    t3 = {
      required
    };
    $[6] = required;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== control || $[9] !== name || $[10] !== t2 || $[11] !== t3) {
    t4 = <Controller control={control} defaultValue="" name={name} render={t2} rules={t3} />;
    $[8] = control;
    $[9] = name;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== errors || $[14] !== name || $[15] !== required) {
    t5 = required && errors[name] && <Error />;
    $[13] = errors;
    $[14] = name;
    $[15] = required;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t1 || $[18] !== t4 || $[19] !== t5 || $[20] !== width) {
    t6 = <Width width={width}>{t1}{t4}{t5}</Width>;
    $[17] = t1;
    $[18] = t4;
    $[19] = t5;
    $[20] = width;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};
function _temp(t0) {
  const {
    label: label_0,
    value: value_0
  } = t0;
  return <SelectItem key={value_0} value={value_0}>{label_0}</SelectItem>;
}